import { Module } from 'vuex';
import { DefineMutations } from 'vuex-type-helper';
import { RootState } from '../index';

export interface ModuleState {
    name: string;
    email: string;
    loading: boolean;
}

export interface ModuleMutations {
    updateName: string;
    updateEmail: string;
    updateLoading: boolean;
}

const state: ModuleState = {
    name: '',
    email: '',
    loading: false,
};

const mutations: DefineMutations<ModuleMutations, ModuleState> = {
    updateName(s: ModuleState, name: string): void {
        s.name = name;
    },
    updateEmail(s: ModuleState, email: string): void {
        s.email = email;
    },
    updateLoading(s: ModuleState, loading: boolean): void {
        s.loading = !!loading;
    },
};

const module: Module<ModuleState, RootState> = {
    namespaced: true,
    state,
    mutations,
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/newsletter.ts